import {Inject, Injectable, PLATFORM_ID} from '@angular/core';
import {AppStore} from './model/app-store.model';
import {Store} from '@ngrx/store';
import {AppHeaderChangedState} from './states/app-heade-changed.state';
import {LocalStorage} from './storage/local-storage';
import {isPlatformBrowser} from "@angular/common";
import {LocalStorageConstant} from "./constants/user.storage.const";
import {UserState} from "./states/app.user.state";
import {AppRestaurantState} from "./states/app.restaurant.state";
import {SubscriptionPlan} from "../../models/SubscriptionPlan";
import {FeaturePlan} from 'src/app/models/FeaturePlan';
import {SessionStorage} from "./storage/session-storage";
import {resetNavPermissionSync} from "../../layout/nav-permission-sync.state";

@Injectable({
  providedIn: 'root'
})
export class AppStateService {
  private readonly _restaurantState: AppRestaurantState;
  private readonly _headerChangedState: AppHeaderChangedState;
  private readonly _isBrowser: boolean;
  private readonly _userState: UserState;

  constructor(private readonly store: Store<AppStore>, @Inject(PLATFORM_ID) private readonly platformId) {
    this._isBrowser = isPlatformBrowser(platformId);
    this._headerChangedState = new AppHeaderChangedState(this.store)
    this._userState = new UserState(this, store);
    this._restaurantState = new AppRestaurantState();
  }

  set loadPermissions(data: string[]) {
   LocalStorage.setPermissions(data);
  }

  get permissions(): string[] {
    return LocalStorage.getPermissions();
  }

  get isBrowser() {
    return this._isBrowser
  }

  get lastActionUrl() {
    return LocalStorage.getLocalString(LocalStorageConstant.LAST_ACTION_URL)
  }


  get restaurant(): AppRestaurantState {
    return this._restaurantState;
  }

  get user() {
    return this._userState;
  }

  set lastActionUrl(url: string) {
    LocalStorage.setLocalString(LocalStorageConstant.LAST_ACTION_URL, url);
  }

  get headerChanged(): AppHeaderChangedState {
    return this._headerChangedState;
  }

  set selectFeature(feature: FeaturePlan) {
    LocalStorage.setLocalString(LocalStorageConstant.SELECTED_FEATURE, JSON.stringify(feature));
  }

  get selectFeature(): FeaturePlan {
    const raw = LocalStorage.getLocalString(LocalStorageConstant.SELECTED_FEATURE);
    if (!raw) {
      return null;
    }
    try {
      return JSON.parse(raw);
    } catch {
      return null;
    }
  }

  set selectPlan(plan: SubscriptionPlan) {
    LocalStorage.setLocalString(LocalStorageConstant.SELECTED_PLAN, JSON.stringify(plan));
  }

  get selectPlan(): SubscriptionPlan {
    const raw = LocalStorage.getLocalString(LocalStorageConstant.SELECTED_PLAN);
    if (!raw) {
      return null;
    }
    try {
      return JSON.parse(raw);
    } catch {
      return null;
    }
  }

  reset() {
    resetNavPermissionSync();
    LocalStorage.resetLocal();
    SessionStorage.resetSession();
  }

}
